import { createFileRoute } from '@tanstack/react-router';
import { head } from '@pages/SolutionsDurableWeb3WorkflowsPage.head';
import { SolutionsDurableWeb3WorkflowsPage } from '@pages/SolutionsDurableWeb3WorkflowsPage';

export const Route = createFileRoute('/solutions/durable-web3-workflows')({
  component: SolutionsDurableWeb3WorkflowsPage,
  head: () => head,
});
